import { INVALID_STATUSES } from "diagnostics-domain/quantity/metrology";
import type { MetrologyStatus } from "diagnostics-domain/quantity/metrology";

type AnalysisLike = {
  date: number;
  quantityValues: {
    [quantityId: string]: {
      metrology: {
        status: MetrologyStatus;
        crossInvalidityEvaluatedQuantityId: string | null;
      };
    };
  };
};

function getBackendMetrology(analysis: AnalysisLike, quantityId: string) {
  const quantityValue = analysis.quantityValues[quantityId];
  if (quantityValue === undefined || !("metrology" in quantityValue)) return null;

  return quantityValue.metrology ?? null;
}

export function getAnalysisQuantityMetrologyStatus(
  analysis: AnalysisLike,
  quantity: { id: string },
): MetrologyStatus {
  const backendMetrology = getBackendMetrology(analysis, quantity.id);
  if (backendMetrology === null) return "NO_VALIDATION";

  return backendMetrology.status;
}

export function isAnalysisQuantityValid(analysis: AnalysisLike, quantity: { id: string }) {
  if (analysis.quantityValues[quantity.id] === undefined) return false;

  return !INVALID_STATUSES.has(getAnalysisQuantityMetrologyStatus(analysis, quantity));
}

export function getAnalysisCrossInvalidityEvaluatedQuantityId(
  analysis: AnalysisLike,
  quantity: { id: string },
) {
  const backendMetrology = getBackendMetrology(analysis, quantity.id);
  if (backendMetrology === null) return null;

  return backendMetrology.crossInvalidityEvaluatedQuantityId;
}
